
import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import { DocumentsStore } from '@/store/modules/Documents';
import Api from "@/repository/api";
import { getStudioId } from "@/UI/lib/state";

@Component({
  components: {PageTitle}
})

export default class SalonDocs extends Vue {
  data: any = [];
  DocumentsFileList: any =  []

  async handleChangeDocumentFile(file: any) {
    console.clear()
    console.error(file.file)
    const fd = new FormData()
    fd.append('salon_id', getStudioId(this))
    fd.append('file', new Blob(file.fileList), file.fileList[0].name)
    await DocumentsStore.save(fd)
  }

  onRemoveDocumentFile() {
    this.DocumentsFileList = []
  }

  async created() {
    // 14294
    await DocumentsStore.fetchAll({filter: {salon_id: getStudioId(this)}})
    this.data = DocumentsStore.items?.data
    console.warn(this.data)
  }

  get salonDocsColumns(): ITableColumn[] {
    return TablesStore.salonDocsColumns;
  }
}
